import { render, staticRenderFns } from "./BaseRightModal.vue?vue&type=template&id=f20252b8&scoped=true"
import script from "./BaseRightModal.vue?vue&type=script&lang=js"
export * from "./BaseRightModal.vue?vue&type=script&lang=js"
import style0 from "./BaseRightModal.vue?vue&type=style&index=0&id=f20252b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20252b8",
  null
  
)

export default component.exports